import { RUMEntry, RUMFilter } from '@pulse/common';

export function rumEntryMatch(entry: RUMEntry, filter: RUMFilter) {
    const type = typeof filter === 'string' ? filter : filter?.entryType;
    const typeMatch = entry.entry_type === type;
    const nameMatch = rumEntryNameMatch(entry.name, filter);
    const filterMatch =
        typeof filter === 'object' && typeof filter.filter === 'function'
            ? filter.filter(entry)
            : true;
    const match = typeMatch && nameMatch && filterMatch;

    return match;
}

export function rumEntryNameMatch(name: string, filter: RUMFilter) {
    if (typeof filter === 'string') {
        return true;
    }

    if (typeof filter.name === 'undefined') {
        return true;
    }

    if (Array.isArray(filter.name)) {
        return filter.name.some((i) => {
            if (i instanceof RegExp) {
                return i.test(name);
            } else {
                return i === name;
            }
        });
    }

    return false;
}
